import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import map from 'lodash/map';

const NotificationSection = ({ name, section, Component, user, atAdmin }) => (
  <div className="notification-subsection">
    <div className="row">
      <div className="small-16 medium-4 column">
        <div className="notification-section-header">
          <h5>{ name }</h5>
          <p>Notify { atAdmin? `${user.username}` : 'me' } when&hellip;</p>
        </div>
      </div>
    </div>
    { map(section, (notification, key) => (
      <Component
        key={v4()}
        id={key}
        notification={notification}
      />
    ))}
  </div>
);

NotificationSection.propTypes = {
  name: PropTypes.string,
  section: PropTypes.object,
  user: PropTypes.object.isRequired,
  atAdmin: PropTypes.bool.isRequired,
  Component: PropTypes.func.isRequired,
};

export default NotificationSection;



// WEBPACK FOOTER //
// ./account/components/notification_section.jsx